import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { IProfileRate } from '../../models/IProfileRate';
import { FezaDataService } from '../../services/fezadata.service';
import { S1DataService } from '../../services/s1data.service';

@Component({
  selector: 'profile-rate',
  templateUrl: './profile-rate.component.html',
  styleUrls: ['./profile-rate.component.css']
})
export class ProfileRateComponent implements OnInit {
  @Input() countryCode: string;
  @Input() questionId: number;
  @Input() locale: string;
  questionName: string="";
  rate: IProfileRate = null;

  constructor(private fezaService: FezaDataService, private s1Service: S1DataService) {
  }

  ngOnInit() {
    var errRate = ({ isError: true, errorMessage: "error getting data" } as IProfileRate);
    this.fezaService.GetPanelProfile(this.countryCode, this.questionId).subscribe(rate => { this.rate = rate }, err => this.rate = errRate);
    this.s1Service.getQuestions(this.locale).subscribe(qs => qs.filter(q => q.id == this.questionId).forEach(q => this.questionName = q.name));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/profile-rate/profile-rate.component.ts